import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';

@Component({
  selector: 'qrcode-dialog',
  templateUrl: './qrcode-dialog.component.html',
  styleUrls: ['./qrcode-dialog.component.scss'],
  standalone: false
})
export class QrcodeDialogComponent {
  image = '';
  close = '';
  download = '';

  constructor(public dialogRef: MatDialogRef<QrcodeDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private ts: TranslateService) {
    this.image = this.data?.image || this.image;
    this.close = this.ts.get('general.close');
    this.download = this.ts.get('general.download');
  }

  downloadQrCode(image) {
    Object.assign(document.createElement('a'), { href: image, download: 'QrCode.png' }).click();
    this.dialogRef.close();
  }
}
